import PropTypes from 'prop-types'
import classNames from 'classnames'

import ArticleItem from 'components/ArticleItem'

import s from './ArticleGrid.module.css'

function ArticleGrid({ articles = [], className = '', articleClassName = '' }) {
  if (articles?.length < 1) return null

  return (
    <div className={classNames(s.container, className, 'articleGrid')}>
      {articles.map((p) => (
        <ArticleItem
          key={p.id}
          className={classNames(s.article, articleClassName)}
          {...p}
        />
      ))}
    </div>
  )
}

ArticleGrid.propTypes = {
  articles: PropTypes.array,
  className: PropTypes.string,
  articleClassName: PropTypes.string,
}

export default ArticleGrid
